module.exports = __webpack_public_path__ + "static/img/2.08ece18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/qiye/20200920/2.png
// module id = E6Ub
// module chunks = 1